import { render, staticRenderFns } from "./ConfigManutencao.vue?vue&type=template&id=a2af08fc&"
import script from "./ConfigManutencao.vue?vue&type=script&lang=js&"
export * from "./ConfigManutencao.vue?vue&type=script&lang=js&"
import style0 from "./ConfigManutencao.vue?vue&type=style&index=0&id=a2af08fc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports